<template>
  <div class="customer-detail-view">
    <title-component
      :size="1"
      :lineSeparator="'under'">
      <translate>Customer detail view</translate>
      <action-dropdown-component :actions="actions"></action-dropdown-component>
    </title-component>
    <!-- Customer details -->
    <grid-details-component
      v-if="customer.id"
      :display_spec="customerProfileSpecs"
      :item="customer"
      :item_keys="customer_keys">
    </grid-details-component>
    <!-- Tabs -->
    <tabs-router-component :tabs="routes">
    </tabs-router-component>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { customerProfileSpecs, defaultCustomerKeys } from '@/display_context/display_context'
  import TitleComponent from '@/components/layout/TitleComponent'
  import GridDetailsComponent from '@/components/layout/grid/GridDetailsComponent'
  import TabsRouterComponent from '@/components/layout/tabs/TabsRouterComponent.vue'
  import ActionDropdownComponent from '@/components/layout/utility/ActionDropdownComponent'
  import { setContainedHeightMixin, errorHandler } from '@/mixins/mixins'

  export default {
    name: 'customer-detail-view',
    mixins: [setContainedHeightMixin, errorHandler],
    components: {
      ActionDropdownComponent,
      TitleComponent,
      GridDetailsComponent,
      TabsRouterComponent
    },
    data () {
      return {
        customer_keys: defaultCustomerKeys,
        actions: [],
        customerProfileSpecs: customerProfileSpecs,
        routes: [
          {
            route: { name: 'InvoicingView' },
            text: 'Invoicing'
          },
          {
            route: { name: 'DocumentsView' },
            text: 'Documents'
          },
          {
            route: { name: 'CustomerCasesView' },
            text: 'Cases'
          }
        ]
      }
    },
    computed: {
      ...mapState({
        customer: state => state.profileModule.customerProfile
      })
    },
    methods: {
      ...mapActions([
        'getCustomerProfile'
      ]),
      setActions () {
        this.actions = [
          {
            type: 'ROUTE',
            route: { name: 'CustomerEditView' },
            text: 'Edit information...'
          }
        ]
      },
      switchCustomerKeys () {
        if (this.customer.hasAdditionalCommunes) {
          if (!this.customer_keys.includes('communes')) {
            this.customer_keys.push('communes')
          }
        }
      }
    },
    created () {
      this.getCustomerProfile().catch((err) => {
        this.handleError(err)
      })
      this.setActions()
      this.switchCustomerKeys()
    }
  }
</script>
